// import  { useState, useEffect } from "react";

// data
// import DataSuggest from "../../Assets/Data/suggest.js";

const Suggestions = () => {
  // const [data, setData] = useState();

  // useEffect(() => {
  //   return () => {
  //     setData(DataSuggest);
  //   };
  // }, []);

  return (
    <div className="mt-6">
      <div>
        <p
          style={{
            color: "#3C4048",
            fontWeight: "600",
            textTransform: "uppercase",
            fontSize: "13px",
          }}
        >
          My tool's stack
        </p>
      </div>
      <div className="flex items-center justify-between mt-5">
          <div className="flex items-center">
            <div className="w-8  h-8">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png" alt="suggestions" className="rounded-full" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-semibold">Visual Studio Code</p>
              <p className="text-xs text-gray-500">Code Editor</p>
            </div>
          </div>
          <a
            href="https://code.visualstudio.com/"
            style={{ color: "#0095f6", fontSize: "14px", fontWeight: "600" }}
          >
            look
          </a>
        </div>

        <div className="flex items-center justify-between mt-5">
          <div className="flex items-center">
            <div className="w-8  h-8">
              <img src="https://www.svgrepo.com/show/327388/logo-react.svg" alt="suggestions" className="rounded-full" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-semibold">React.js</p>
              <p className="text-xs text-gray-500">Program Library(web-app)</p>
            </div>
          </div>
          <a
            href="https://reactjs.org/"
            style={{ color: "#0095f6", fontSize: "14px", fontWeight: "600" }}
          >
            look
          </a>
        </div>

        <div className="flex items-center justify-between mt-5">
          <div className="flex items-center">
            <div className="w-8  h-8">
              <img src="https://res.cloudinary.com/crunchbase-production/image/upload/c_lpad,h_170,w_170,f_auto,b_white,q_auto:eco,dpr_1/q4q8emquy5eivdz4quk7" alt="suggestions" className="rounded-full" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-semibold">React Native Expo</p>
              <p className="text-xs text-gray-500">Open-source platform(native apps)</p>
            </div>
          </div>
          <a
            href="https://reactjs.org/"
            style={{ color: "#0095f6", fontSize: "14px", fontWeight: "600" }}
          >
            look
          </a>
        </div>

        <div className="flex items-center justify-between mt-5">
          <div className="flex items-center">
            <div className="w-8  h-8">
              <img src="https://img.icons8.com/small/2x/console.png" alt="suggestions" className="rounded-full" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-semibold">Hyper</p>
              <p className="text-xs text-gray-500">Command-line(Terminal)</p>
            </div>
          </div>
          <a
            href="https://hyper.is/"
            style={{ color: "#0095f6", fontSize: "14px", fontWeight: "600" }}
          >
            look
          </a>
        </div>

      <div className="mt-6 text-xs text-semibold">
        <p style={{ color: "#B2B2B2" }}> © 2022 Joel Deon Dsouza</p>
      </div>
    </div>
  );
};

export default Suggestions;
